import { c as _c } from "react/compiler-runtime";
import type { Option } from '@newfront-insurance/core-ui';
import { AdvancedSelectInput } from '@newfront-insurance/core-ui';
import type { LineOfCoverageType } from '@newfront-insurance/coverage-api';
import { useCallback, useMemo, type JSX } from 'react';
import { useDefinitionsHelpers } from '../../hooks/definitions';
export interface Props {
  /** The current value of the select */
  value?: LineOfCoverageType;
  /** An array of types you want to filter out so that they don't get displayed in the options list */
  blacklist?: LineOfCoverageType[];
  onChange: (lineOfCoverageType: LineOfCoverageType) => unknown;
}

/**
 * Select with all lines of coverage types (except for the ones in the optional blacklist)
 */
export function LineOfCoverageTypeSelectInput(t0) {
  const $ = _c(16);
  const {
    value,
    blacklist: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const blacklist = t2;
  const {
    lineOfCoverageTypes,
    renderLineOfCoverageType
  } = useDefinitionsHelpers();
  let t3;
  let t4;
  if ($[2] !== blacklist || $[3] !== lineOfCoverageTypes || $[4] !== renderLineOfCoverageType) {
    let t5;
    if ($[6] !== blacklist) {
      t5 = type => !blacklist.includes(type);
      $[6] = blacklist;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== renderLineOfCoverageType) {
      t6 = type_0 => ({
        value: type_0,
        label: renderLineOfCoverageType(type_0)
      });
      $[8] = renderLineOfCoverageType;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t4 = lineOfCoverageTypes.filter(t5).map(t6);
    $[2] = blacklist;
    $[3] = lineOfCoverageTypes;
    $[4] = renderLineOfCoverageType;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  t3 = t4;
  const options = t3;
  let t5;
  if ($[10] !== onChange) {
    t5 = val => onChange(val as LineOfCoverageType);
    $[10] = onChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleChange = t5;
  let t6;
  if ($[12] !== handleChange || $[13] !== options || $[14] !== value) {
    t6 = <AdvancedSelectInput isClearable={true} value={value} options={options} onChange={handleChange} />;
    $[12] = handleChange;
    $[13] = options;
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}